import React, {useEffect, useId, useRef, useState} from 'react';
import {Box} from '@mui/material';

// Рендерит один рекламный блок РСЯ по его block-id. Контейнеру нужен уникальный
// DOM id на каждый монтированный экземпляр — иначе при нескольких блоках с
// одним и тем же blockId на странице (например, {{ad}} в нескольких статьях
// подряд) Yandex.Context не сможет понять, в какой контейнер рендерить какой.
// collapseWhenEmpty — если реклама не загрузилась (блокировщик, нет показа), через несколько секунд пустое место убираем.
const YandexAdBlock = ({blockId, minHeight = 100, type, collapseWhenEmpty = false}) => {
    const [collapsed, setCollapsed] = useState(false);
    const containerId = `yandex_rtb_${blockId}_${useId().replace(/:/g, '')}`;
    const rendered = useRef(false);

    useEffect(() => {
        if (rendered.current) return;
        rendered.current = true;

        window.yaContextCb = window.yaContextCb || [];
        window.yaContextCb.push(() => {
            if (window.Ya && window.Ya.Context && window.Ya.Context.AdvManager) {
                window.Ya.Context.AdvManager.render({
                    blockId,
                    renderTo: containerId,
                    // Блоки типа "Лента" требуют явный type: "feed" в конфиге
                    // render — без него Yandex.Context отвечает
                    // RESPONSE_MISMATCH_BANNER_CFG и ничего не рендерит.
                    ...(type ? {type} : {}),
                });
            }
        });
    }, [blockId, containerId, type]);

    useEffect(() => {
        if (!collapseWhenEmpty) return undefined;
        const timer = setTimeout(() => {
            const el = document.getElementById(containerId);
            if (el && el.childElementCount === 0) setCollapsed(true);
        }, 4000);
        return () => clearTimeout(timer);
    }, [collapseWhenEmpty, containerId]);

    return <Box id={containerId} sx={{minHeight: collapsed ? 0 : minHeight, width: '100%'}}/>;
};

export default YandexAdBlock;
